var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.SignInRuleConfig, {
        attrs: { "sign-in-rule": _vm.localForm.signInRule },
      }),
      _c(_setup.SignInTiersConfig, {
        attrs: { tiers: _vm.localForm.signInTiers },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }